import React from "react";
import styled, { css } from "styled-components";
import { space, typography, color, flexbox, margin, size } from "styled-system";
import formatter from "../../../modules/formatter";
// import { Flex, Box } from "reflexbox/styled-components";

const BaseText = styled.div`
  margin: 0;
  padding: 0;
  width: ${({ width, w }) => (width ? width : w ? w : "100%")};

  text-align: ${(props) => {
    if (props.center) return "center;";
    if (props.right) return "right;";
    return "left";
  }};
  text-decoration: ${(props) => {
    if (props.linethrough) return "line-through;";
    return "none";
  }};
  font-weight: ${(props) => (props.bold ? "600" : "400")};
  line-height: 1.5;
  ${({ ellipsis, lines }) => {
    if (ellipsis) {
      let ret = css`
        word-break: break-all;
        min-width: 1rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        display: -webkit-box;
        -webkit-line-clamp: ${({ lines = 1 }) => lines};
        -webkit-box-orient: vertical;
      `;

      return ret;
    }
  }}
  ${space};
  ${color};
  ${typography};
  ${flexbox};
  ${size};
  ${margin};
`;

export const Heading = styled(BaseText)`
  font-size: 2rem;
  flex: unset;
`;

export const Body = styled(BaseText)`
  font-size: 1rem;
`;

export const Helper = styled(BaseText)`
  font-size: 0.75rem;
`;
export const Date = styled(BaseText)`
  justify-content: center;
  text-align: center;
`;
export const Currency = ({ value, children }) => {
  return (
    <BaseText right>
      ${formatter.currency(value ? value : +children?.[0])}
    </BaseText>
  );
};
